import * as yup from "yup";
import { useQuery } from "@tanstack/react-query";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../consts/api";
import { http } from "../../services/HttpService";
import { unwrapOr } from "../../utilities/general";

const requestSchema = yup.object({
  categoryId: yup.number().required(),
});

const responseSchema = yup
  .array()
  .of(
    yup.object({
      id: yup.number().required(),
      name: yup.string().required(),
      order: yup.number().nullable(),
    }),
  )
  .required();

const composeResponse = (res) => {
  const data = unwrapOr(() => res.data.data, []);
  return data.map((d) => ({
    id: d.id,
    name: d.name,
    order: d.ob_order || null,
  }));
};

function createObOrderedServicesQueryKey(categoryId) {
  return [QUERY_KEYS.obOrderedServices, categoryId];
}

export function useObOrderedServicesQuery({ payload, options = {} }) {
  return useQuery(
    createObOrderedServicesQueryKey(payload.categoryId),
    async () => {
      const req = requestSchema.validateSync(payload, {
        strict: true,
      });
      const res = await http.get(
        HTTP_ENDPOINTS.getObOrderedServicesByCategoryId(req.categoryId),
      );
      return responseSchema.validateSync(composeResponse(res), {
        strict: true,
      });
    },
    options,
  );
}
